module.exports = __webpack_public_path__ + "img/icon-score2.899b4f26.svg";